import type { WPImageType } from '@Types/Shared/Image';

import { useEffect, useState } from 'react';

import apiFetch from '@wordpress/api-fetch';

export default function Images({ images }: { images: number[] }) {
	return (
		<ul className='flex flex-wrap content-center gap-10'>
			{images.map((image) => (
				<li key={image}>
					<SingleImage imageId={image} />
				</li>
			))}
		</ul>
	);
}

const SingleImage = ({ imageId }: { imageId: number }) => {
	const [image, setImage] = useState<string | null>(null);

	useEffect(() => {
		apiFetch<WPImageType>({ path: `/wp/v2/media/${imageId}` }).then((result) => {
			setImage(result.source_url);
		});
	}, []);

	return <>{image && <img src={image} alt='' className='size-auto max-h-24 max-w-32' />}</>;
};
